import React from 'react';
import { PhoneIcon, ClockIcon } from 'lucide-react';
export function CallToAction() {
  return <div className="w-full bg-gradient-to-br from-yellow-400 via-yellow-300 to-yellow-400 py-12 md:py-20 px-4" data-id="element-25">
      <div className="max-w-4xl mx-auto text-center" data-id="element-26">
        <h2 className="text-2xl md:text-5xl font-bold text-black mb-4 md:mb-6" data-id="element-27">
          Ready to Protect Your Home?
        </h2>
        <p className="text-lg md:text-2xl text-gray-900 mb-6 md:mb-8 font-semibold" data-id="element-28">
          Call Today for a Home Safety Inspection
        </p>
        <div className="flex flex-col sm:flex-row gap-4 md:gap-6 justify-center items-center mb-6 md:mb-8" data-id="element-29">
          <a href="tel:407-655-9436" className="inline-flex items-center gap-2 md:gap-3 bg-red-600 hover:bg-red-700 text-white px-6 py-3 md:px-10 md:py-5 text-xl md:text-3xl font-bold rounded-lg transition-colors shadow-lg" data-id="element-30">
            <PhoneIcon className="w-6 h-6 md:w-10 md:h-10" data-id="element-31" />
            407-655-9436
          </a>
          <div className="flex items-center gap-2 md:gap-3 bg-black text-white px-4 py-3 md:px-6 md:py-4 rounded-lg" data-id="element-32">
            <ClockIcon className="w-5 h-5 md:w-6 md:h-6" data-id="element-33" />
            <span className="text-sm md:text-base font-bold" data-id="element-34">
              Open 7 Days a Week
            </span>
          </div>
        </div>
        <div className="bg-white rounded-lg p-6 md:p-8 shadow-xl" data-id="element-35">
          <p className="text-lg md:text-2xl font-bold text-red-600 mb-3 md:mb-4" data-id="element-36">
            FREE ESTIMATES • SENIOR DISCOUNTS AVAILABLE
          </p>
          <p className="text-base md:text-lg text-gray-700" data-id="element-37">
            Experience the difference that honesty, integrity, and compassion
            make. Your home deserves the best care, and we're here to deliver
            it.
          </p>
        </div>
      </div>
    </div>;
}